import React from "react";
import { Output } from "../../Text";
import {
  BackToTop as BronsonToTop,
  Footer as BronsonFooter,
} from "@vwfs-bronson/bronson-react";
import { Route } from "../../common/Navigation";
import { isVtiBOP } from '../../common/JourneyType';
export const BackToTop = () => (
    <BronsonToTop
        onClick={(e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
    >
      {Output.resolve("pages.container.footer.backToTop")}
    </BronsonToTop>
);

const footerElements = [
  {
    href: Output.resolve("pages.container.footer.metaNav.imprintHref"),
    text: Output.resolve("pages.container.footer.metaNav.imprintText"),
  },
  {
    href: Route.TermsAndConditionsPage,
    text: Output.resolve("pages.container.footer.metaNav.termsOfUseText"),
  },
  {
    href: Route.DataProtection,
    text: Output.resolve(
        "pages.container.footer.metaNav.legalText"
    ),
  },
  {
    href: Route.Licenses,
    text: Output.resolve(
        "pages.container.footer.metaNav.thirdPartyLicenceNotesText"
    ),
  },
  {
    href: Output.resolve("pages.container.footer.metaNav.arbitrationHref"),
    text: Output.resolve("pages.container.footer.metaNav.arbitrationText"),
  }
];

const footerElementsVTI = [
  {
    href: Output.resolve("pages.container.footer.metaNav.vti.imprintHref"),
    text: Output.resolve("pages.container.footer.metaNav.vti.imprintText"),
  },
  {
    href: Route.TermsAndConditionsPage,
    text: Output.resolve("pages.container.footer.metaNav.vti.termsOfUseText"),
  },
  {
    href: Route.DataProtection,
    text: Output.resolve(
        "pages.container.footer.metaNav.vti.legalText"
    ),
  },
  {
    href: Output.resolve("pages.container.footer.metaNav.vti.thirdPartyLicenceNotesHref"),
    text: Output.resolve(
        "pages.container.footer.metaNav.vti.thirdPartyLicenceNotesText"
    ),
  },
  {
    href: Output.resolve("pages.container.footer.metaNav.vti.arbitrationHref"),
    text: Output.resolve("pages.container.footer.metaNav.vti.arbitrationText"),
  },
  {
    href: Output.resolve("pages.container.footer.metaNav.vti.vwfsGebrauchtwagenHref"),
    text: Output.resolve("pages.container.footer.metaNav.vti.vwfsGebrauchtwagenText"),
  }
];

const getFooterItems = (originSystem) => {
  const elements =
  isVtiBOP(originSystem) ? footerElementsVTI : footerElements

    const buildHref = element => {
      return isVtiBOP(originSystem) && Object.values(Route).some((v) => v === element.href)
        ? `${element.href}/vti`
        : element.href
    }
  return elements.map((element) => {
    return(
        <BronsonFooter.ModuleMetaNav.Item
            normalLink
            linkProps={{
              target: "_blank",
            }}
            href={buildHref(element)}
            key={element.text}
            testid={element.text}
        >
          {element.text}
        </BronsonFooter.ModuleMetaNav.Item>
      );
  });
};

export const Footer = ({isSummary, originSystem}) => (
    <BronsonFooter>
      <BronsonFooter.ModuleMetaNav
          copyrightText={Output.resolve("pages.container.footer.entityDisclaimer")}
      >
        {getFooterItems(originSystem)}
      </BronsonFooter.ModuleMetaNav>
      {isSummary && (
          <BronsonFooter.ModuleFootnotes>
            {Output.resolveAsMarkdown("pages.summary.footerText")}
          </BronsonFooter.ModuleFootnotes>
      )}
    </BronsonFooter>
);
